var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AB0A3D;}\n\t.st1{fill:#003A5D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_518_1_",
    transform: "translate(10.186 0.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405_1_",
    className: "st0",
    d: "M11.3,79.5l-4.1-5.4c-0.7-0.9-0.5-2.3,0.4-3c0.4-0.3,0.8-0.4,1.3-0.4h9.5    c0.7,0,1.3,0.3,1.7,0.9l4.1,5.4c0.7,0.9,0.5,2.3-0.4,3c-0.4,0.3-0.8,0.4-1.3,0.4H13C12.4,80.4,11.7,80.1,11.3,79.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519_1_",
    transform: "translate(10.185 41.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406_1_",
    className: "st0",
    d: "M7.3,84.3l4.1-5.4c0.4-0.5,1-0.9,1.7-0.9h9.5c1.2,0,2.1,1,2.1,2.1c0,0.5-0.1,0.9-0.4,1.3    l-4.1,5.4c-0.4,0.5-1,0.9-1.7,0.9H9c-1.2,0-2.1-1-2.1-2.1C6.8,85.1,7,84.7,7.3,84.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_520_1_",
    transform: "translate(0 9.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407_1_",
    className: "st1",
    d: "M5.8,102.8l7.4-9.8c1-1.4,1-3.3,0-4.6l-7.4-9.8c-1.3-1.7-0.9-4.1,0.8-5.4    c0.7-0.5,1.5-0.8,2.3-0.8h5.2c1.2,0,2.4,0.6,3.1,1.5L28,88.3c1,1.4,1,3.3,0,4.6l-10.8,14.4c-0.7,1-1.9,1.5-3.1,1.5H8.9    c-2.1,0-3.9-1.7-3.9-3.9C5.1,104.2,5.3,103.4,5.8,102.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_521_1_",
    transform: "translate(33.563 9.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408_1_",
    className: "st0",
    d: "M58.1,88.9c0.2-3.1-2.2-5.7-5.3-5.9c-0.2,0-0.4,0-0.6,0c-3.2-0.2-5.9,2.3-6,5.4    c0,0.2,0,0.3,0,0.5v18.6c0,0.7-0.6,1.3-1.3,1.3h-9.2c-0.7,0-1.3-0.6-1.3-1.3l0,0V88.9c0.1-3.1-2.3-5.7-5.4-5.9c-0.1,0-0.3,0-0.4,0    c-3.1-0.2-5.8,2.3-6,5.4c0,0.2,0,0.3,0,0.5v18.6c0,0.7-0.6,1.3-1.3,1.3h0h-9.2c-0.7,0-1.3-0.6-1.3-1.3c0,0,0,0,0,0V74.3    c0-0.7,0.6-1.3,1.3-1.3c0,0,0,0,0,0h8.4c0.6,0,1.2,0.5,1.3,1.1v0c0.1,0.7,0.7,1.2,1.4,1.1c0.2,0,0.5-0.1,0.7-0.3    c2.7-1.9,6-2.9,9.3-2.8c4.1,0,8.2,1.5,10.4,4.5c0.4,0.6,1.2,0.7,1.7,0.3c0.1,0,0.1-0.1,0.2-0.2c2.8-3,6.8-4.7,11-4.6    c6.9,0,13.4,4.5,13.4,13.3v22c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0h-9.2c-0.7,0-1.3-0.6-1.3-1.3v0V88.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_522_1_",
    transform: "translate(89.012 9.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409_1_",
    className: "st0",
    d: "M31.2,108.2H22c-0.7,0-1.3-0.6-1.3-1.3c0,0,0,0,0,0V73.7c0-0.7,0.6-1.3,1.3-1.3c0,0,0,0,0,0    h9.2c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0v33.2C32.5,107.6,31.9,108.2,31.2,108.2C31.2,108.2,31.2,108.2,31.2,108.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_523_1_",
    transform: "translate(103.046 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410_1_",
    className: "st0",
    d: "M40.7,91.7c-0.7,0-1.3,0.6-1.3,1.3v10.3c0,5.6,4.5,5.6,9.7,4.5c0.7-0.1,1.4,0.3,1.5,1    c0,0,0,0.1,0,0.1l0.6,7.1c0.1,0.6-0.3,1.1-0.9,1.3c-2.8,0.8-5.6,1.3-8.5,1.3c-8.2,0-14.1-3.9-14.1-13.5V93c0-0.7-0.6-1.3-1.3-1.3    c0,0,0,0,0,0h-2c-0.7,0-1.3-0.6-1.3-1.3c0,0,0,0,0,0v-7c0-0.7,0.6-1.3,1.3-1.3h0h2c0.7,0,1.3-0.6,1.3-1.3l0,0v-8.9    c0-0.7,0.6-1.3,1.3-1.3l0,0h8.8c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0v8.9c0,0.7,0.6,1.3,1.3,1.3c0,0,0,0,0,0h7.6    c0.7,0,1.3,0.6,1.3,1.3v7c0,0.7-0.6,1.3-1.3,1.3H40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524_1_",
    transform: "translate(128.449 9.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411_1_",
    className: "st0",
    d: "M55,107.7L55,107.7c-0.1-0.7-0.7-1.2-1.4-1.1c-0.2,0-0.5,0.1-0.7,0.3    c-2.5,1.9-5.6,2.8-8.7,2.7c-9.5,0-16.5-7.9-16.5-18.6s7-18.7,16.5-18.7c3.1-0.1,6.2,0.9,8.7,2.8c0.5,0.4,1.3,0.4,1.8-0.2    c0.2-0.2,0.3-0.4,0.3-0.7v0c0.1-0.6,0.6-1.1,1.3-1.1h9c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0v33.2c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0    h-9C55.6,108.8,55.1,108.3,55,107.7 M39.3,91c0,4.8,3.2,8.2,7.7,8.2s7.7-3.4,7.7-8.2s-3.2-8.2-7.7-8.2    C42.5,82.7,39.3,86.1,39.3,91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525_1_",
    transform: "translate(86.344 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412_1_",
    className: "st1",
    d: "M32.6,74.3l-2.1-2.7c-0.4-0.5-1-0.9-1.7-0.9h-6.4c-1.2,0-2.1,1-2.1,2.1    c0,0.5,0.2,0.9,0.4,1.3l2.1,2.7c0.4,0.5,1,0.9,1.7,0.9h6.4c1.2,0,2.1-1,2.1-2.1C33,75.1,32.8,74.7,32.6,74.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMita);
export default __webpack_public_path__ + "static/media/mita.c0c8ac608a5cc2f483073bfb5ddbc5a2.svg";
export { ForwardRef as ReactComponent };